import React, { useContext } from "react";
import Product from "./Product";
import BusinessContext from "context/BusinessContext";
import "./Product.scss";
const Products = ({ items }) => {
  const { space } = useContext(BusinessContext);
  let temp = [];
  for (let i = 0; i < space; i++) {
    temp[i] = "";
  }
  return (
    <div className="products row">
      {items.map((value, index) => {
        return <Product value={value} key={index} isMain={true} />;
      })}
      {temp.map((value, index) => {
        return (
          <div
            className="d-none d-md-block col-md-4 col-lg-3 col-xxl-2"
            style={{ margin: "30px 10px" }}
            key={index}
          >
            {value}
          </div>
        );
      })}
    </div>
  );
};

export default Products;
